import { Navigate } from "react-router-dom";

export default function SalesReportRedirect() {
  return <Navigate to="/reports/sales/trend" replace />;
}
